import React from "react";

import Page from "@jumbo/shared/Page";
import Courses from "../pages/courses";
import Course from "../pages/course";
import Profile from "../pages/profile";
import Library from "../pages/library";
import Welcome from "../pages/welcome";
import Video from "../pages/video";
import Category from "../pages/category";

const dashboardRoutes = [
    {
        path: "/",
        element: <Page component={Courses} />,
    },
    {
        path: "/library",
        element: <Page component={Library} />,
    },
    {
        path: "/courses/:id",
        element: <Page component={Course}/>,
    },
    {
        path: "/videos/:id",
        element: <Page component={Video}/>,
    },
    {
        path: "/profile",
        element: <Page component={Profile} />,
    },
    {
        path: "/categories/:id",
        element: <Page component={Category}/>,
    },
    {
        path: "/welcome",
        element: <Page component={Welcome} layout={"solo-page"} />,
    },
];

export default dashboardRoutes;
